import React from "react";
import { Phone } from "lucide-react";
import { useSiteSettings } from "../context/SiteSettingsContext";
import { useLang } from "../context/LanguageContext";
import { track } from "../lib/analytics";

export default function FloatingCall() {
  const { settings } = useSiteSettings() || {};
  const { t, isRTL } = useLang();
  const rawPhone = settings?.general?.phone || "+962 79 944 8817";
  const tel = rawPhone.replace(/[^\d+]/g, "");
  // Stack this button above the WhatsApp floater. We avoid using the same
  // corner as FloatingWhatsApp so both are tappable on mobile.
  return (
    <a
      href={`tel:${tel}`}
      onClick={() => track("call_click")}
      data-testid="floating-call"
      aria-label={t("common.callNow")}
      className={
        // Mobile: opposite corner from the WhatsApp floater (WA is on the
        // language-appropriate "end" side, Call is on the opposite "start"
        // side so thumbs don't clash). Desktop: stacked above the WhatsApp
        // pill on the same side.
        `fixed z-50 group bottom-6 sm:bottom-24 ${
          isRTL
            ? "right-6 sm:right-auto sm:left-6"
            : "left-6 sm:left-auto sm:right-6"
        }`
      }
    >
      <span className="relative flex items-center gap-2.5 px-5 sm:pl-4 sm:pr-5 h-14 rounded-full bg-electric text-white shadow-[0_10px_30px_-10px_rgba(0,85,255,0.6)] hover:bg-electricHover transition-colors duration-300">
        {/* Ping is anchored behind the ICON only (fixed 40x40) so the
            growing pill on hover never fights the animation. Using
            transition-colors (not transition-all) prevents the flicker
            that happened when ping scaling collided with bg/padding tween. */}
        <span className="relative flex items-center justify-center w-10 h-10">
          <span className="absolute inset-0 rounded-full bg-electric animate-ping opacity-40 pointer-events-none" />
          <Phone size={22} strokeWidth={2.5} className="relative" />
        </span>
        <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em]">
          {t("common.callNow")}
        </span>
      </span>
    </a>
  );
}
